export enum BlacklistTypeE {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
  INCOMING_OUTGOING = 'incoming-outgoing',
}
